export const EXTERNAL_HOST = {
  FTCI: 'ftci',
  ELEMENT: 'element',
  ALLY: 'ally',
  MONETA: 'moneta',
  WEALTHCARE: 'wealthcare',
  MERIT: 'MeritFinancial',
  CARSON: 'carson',
};
